var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusicNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 16.2826V5.44922L17.5 2.94922V13.7826M7.5 16.2826C7.5 17.2034 6.38083 17.9492 5 17.9492C3.61917 17.9492 2.5 17.2034 2.5 16.2826C2.5 15.3617 3.61917 14.6159 5 14.6159C6.38083 14.6159 7.5 15.3617 7.5 16.2826ZM17.5 13.7826C17.5 14.7034 16.3808 15.4492 15 15.4492C13.6192 15.4492 12.5 14.7034 12.5 13.7826C12.5 12.8617 13.6192 12.1159 15 12.1159C16.3808 12.1159 17.5 12.8617 17.5 13.7826ZM7.5 8.78255L17.5 6.28255",
    stroke: "url(#paint0_linear_15452_95884)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15452_95884",
    x1: 12.1475,
    y1: 1.28878,
    x2: 7.50573,
    y2: 5.66531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71D1DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71ABEE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicNote);
export default __webpack_public_path__ + "static/media/music-note.0456b339f7ad256ee3120311930b202d.svg";
export { ForwardRef as ReactComponent };